import { createContext, useContext } from "react";
import { IUserData } from "../types";
import { initialUserData } from "./Action";

export const UserDataContext = createContext<IUserData>(initialUserData);
export const UserDataDispatchContext = createContext<Function>(()=>0);

export function useUserDataContext() {
    const context = useContext(UserDataContext);

    if (context===undefined) {
        throw Error("useUserDataContext must be used inside provider");
    }

    return context;
}

export function useUserDataDispatchContext() {
    const context = useContext(UserDataDispatchContext);

    if (context===undefined) {
        throw Error("useUserDataDispatchContext must be used inside Provider");
    }

    return context;
}